export default __webpack_public_path__ + "static/media/Classwin logo_Classwin C - Blue.4d045fdc.svg";